<input type="search" placeholder="Search in bookmarks"
       [ngModel]="searchTerm()"
       (ngModelChange)="searchTerm.set($event); search()" />
